import { useModal } from "../../../../utils/modal_launcher";
import { LogPumpingModal } from "../log_pumping_modal";
import { formatTime, timeAgo } from "./dashboard_utils";

type Props = {
  lastPumping: any;
  refetch: () => void;
};

export const PumpingWidget = ({ lastPumping, refetch }: Props) => {
  const logPumpingModal = useModal(LogPumpingModal);

  return (
    <div className="col-12 col-md-6">
      <div className="card border-0 shadow bg-gray-3 my-4 dashboard-card dashboard-card-primary">
        <div className="card-body text-center">
          <div className="fs-24 fw-bold text-muted text-uppercase">Pumping</div>
          {lastPumping?.ended_at ? (
            <>
              <div className="fs-48 desktop-fs-60 fw-bold mt-2">
                {timeAgo(lastPumping.ended_at)}
              </div>
              <div className="d-flex align-items-center justify-content-center gap-2 fs-m-30 fs-40 gray-c fw-bold mt-3">
                <div>at {formatTime(lastPumping.ended_at)}</div>
                {lastPumping.amount_ml && (
                  <div className="ml-4">{lastPumping.amount_ml} ml</div>
                )}
                <div className="w-0px">
                  <button
                    className="btn btn-text ml-4"
                    style={{ fontSize: "1.2rem", lineHeight: 1 }}
                    onClick={() =>
                      logPumpingModal.show({ pumping: lastPumping, refetch })
                    }
                    aria-label="Edit pumping"
                  >
                    <i className="bi bi-pencil" />
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p className="text-muted">No entries logged yet</p>
          )}
          <div className="container mt-4">
            <button
              className="btn btn-primary fs-28 col-12 col-sm-4"
              onClick={() => logPumpingModal.show({ refetch })}
            >
              Log
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
